export default "__VITE_ASSET__D1Q0ujle__"